import React from 'react';
import { ShareToolFilter } from '@/views/SavedQueries/types';
import { SHARE_TOOL_TYPE_TO_NAME_MAP } from '@/views/SavedQueries/consts';
import { TrevorIcon } from '@trevor/ui-components';
import { SHARE_TOOL_TYPE_TO_ICON_NAME_MAP } from './consts';
import styles from './FilterItem.module.scss';

export type FilterItemProps = {
  type: ShareToolFilter;
  active: boolean;
  onApplyFilter: F0<void>;
  count: number;
};

export const FilterItem: React.FC<FilterItemProps> = ({
  type,
  onApplyFilter,
  active,
  count,
}) => {
  return (
    <div
      onClick={onApplyFilter}
      className={`${styles.container} ${active ? styles.activeFilter : ''}`}
    >
      <div
        style={{
          display: 'flex',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <TrevorIcon
          name={SHARE_TOOL_TYPE_TO_ICON_NAME_MAP[type]}
          className="margin-right-10"
        />
        {SHARE_TOOL_TYPE_TO_NAME_MAP[type]}
      </div>
      <div className={styles.count}>
        <span className="faint margin-right-5">({count})</span>
      </div>
    </div>
  );
};
